
import { React, useState, useRef } from 'react';
import ClaimOffer from './components/ClaimOffer/ClaimOffer';
import Header from './components/Header/Header';
import Showcase from './components/Showcase/Showcase';
import InfoList from './components/InfoList/InfoList';
import './App.css';
import ClaimBox from './components/ClaimPromoBox/ClaimBox';

const MainPage = () => {

  const promoRef = useRef(null);
  return (
    <>
      <Header refProp={promoRef} />
      <ClaimBox refProps={promoRef} />
      <InfoList />
      <Showcase />
      <ClaimOffer refProp={promoRef} />
    </>)
}

export default MainPage